import React from 'react';

import './index.scss';
import { FooterButton } from './molecules';

const YourOrder = ({ children }) => {
  return <div className="pre-book-cart">{children}</div>;
};

const Wrapper = ({ children }) => {
  return <div className="pre-book-cart__outer-wrapper">{children}</div>;
};

const Info = ({ children }) => {
  return <p className="pre-book-cart__info">{children}</p>;
};

const Description = () => {
  return (
    <div className="font product-con">
      <div>
        <h6>Avengers Doomsday Meal</h6>
        <p>Prepaid Doomsday meal · Redeemed for dine-in</p>
      </div>
      <h6>₹0.00</h6>
    </div>
  );
};

const DescriptionTwo = () => {
  return (
    <div className="font green-shadow-product">
      <h6 className="text-green">Pre-book credit applied</h6>
      <p className="text-green">
        This meal was prepaid. Your order value and total payable are ₹0.
      </p>
      <div className="amount-con">
        <h6>Total payable</h6>
        <h6>₹0.00</h6>
      </div>
    </div>
  );
};

YourOrder.Wrapper = Wrapper;

YourOrder.Footer = FooterButton;
YourOrder.Info = Info;
YourOrder.Description = Description;
YourOrder.DescriptionTwo = DescriptionTwo;

export default YourOrder;
